<template>
  <div>
    <!-- TABLET SCREEN -->
    <!-- START -->
    <v-card v-if="checkBreakPoints" elevation="0">
      <div class="d-flex mt-5">
        <v-text-field
          prepend-inner-icon="mdi-magnify"
          outlined
          height="5px"
          :placeholder="$t('search')"
          dense
          v-model="search"
          @click:append="searchFiles"
          @input="resetSearchOnEmpty"
          class="shrink"
        ></v-text-field>
        <v-btn
          :disabled="search.length < 1"
          color="primary"
          height="40"
          width="40"
          max-width="40"
          outlined
          class="ml-8"
          @click="searchFiles"
        >
          <v-icon>mdi-filter-outline</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <div class="py-1 title">{{ from }} - {{ to }} of {{ totalFiles }}</div>
        <v-btn
          class="mx-2"
          fab
          small
          outlined
          color="primary"
          :disabled="tabletTableOptions.page <= 1"
          @click="tabletPageChange(false)"
        >
          <v-icon dark> mdi-chevron-left </v-icon>
        </v-btn>
        <v-btn
          class="mx-2"
          fab
          small
          outlined
          color="primary"
          :disabled="tabletTableOptions.page >= totalPages"
          @click="tabletPageChange(true)"
        >
          <v-icon dark> mdi-chevron-right </v-icon>
        </v-btn>
      </div>
      <v-card
        v-for="(item, index) in items"
        :key="item.userNumber"
        @mouseover="selectItem(item)"
        @mouseleave="unSelectItem()"
        class="inner-card my-4 px-1 py-3"
        :elevation="0"
        :style="
          index % 2 !== 0 && { backgroundColor: 'rgba(243, 243, 243, 0.5)' }
        "
      >
        <v-row no-gutters>
          <v-col md="3">
            <v-card-text style="color: #787878" class="py-1"
              >UIH Number</v-card-text
            >
            <v-card-text class="py-1">{{ `#${item.UIHNumber}` }}</v-card-text>
          </v-col>
          <v-col md="3">
            <v-card-text style="color: #787878" class="py-1"
              >{{$t('orignalName')}}</v-card-text
            >
            <v-card-text class="py-1">{{
              `#${item.originalName}`
            }}</v-card-text>
          </v-col>
          <v-col md="3">
            <v-card-text style="color: #787878" class="py-1"
              >Created At</v-card-text
            >
            <v-card-text class="py-1">{{ item.createdAt }}</v-card-text>
          </v-col>
          <v-col md="3">
            <v-card-text style="color: #787878" class="py-1"
              >{{$t('status')}}</v-card-text
            >
            <v-card-text class="py-1">{{
              item.status == "pending" ? $t('pending') : $t('complete')
            }}</v-card-text>
          </v-col>
        </v-row>
        <div
          style="position: absolute; right: 15px; top: 10px"
          v-if="item === selectedItem"
        >
          <v-tooltip top color="black">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                x-small
                v-bind="attrs"
                v-on="on"
                fab
                class="ml-1 green-shadow"
                @click="downloadFile(item.fileName, item.fileURL)"
              >
                <v-icon>mdi-export</v-icon>
              </v-btn>
            </template>
            <span>Export</span>
          </v-tooltip>
          <v-tooltip top color="black">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                x-small
                v-bind="attrs"
                v-on="on"
                fab
                class="ml-1 green-shadow"
              >
                <v-icon>mdi-trash-can</v-icon>
              </v-btn>
            </template>
            <span>Remove</span>
          </v-tooltip>
        </div>
      </v-card>
    </v-card>
    <!-- END -->
    <v-data-table
      v-else
      :headers="headers"
      :items="items"
      :items-per-page="5"
      v-model="selected"
      show-select
      :loading="$t('loading')"
      :loading-text="$t('user.loadingUser')"
      :footer-props="{
        'items-per-page-options': [5, 25, 50],
        'show-first-last-page': true,
        'show-current-page': true,
        'items-per-page-text': 'Users per page',
      }"
      :options.sync="options"
      :server-items-length="totalFiles"
      hide-default-footer
    >
      <template v-slot:top>
        <div class="d-flex mt-5">
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            outlined
            height="5px"
            placeholder="Search"
            dense
            v-model="search"
            @click:append="searchFiles"
            @input="resetSearchOnEmpty"
            class="shrink"
          ></v-text-field>
          <v-btn
            :disabled="search.length < 1"
            color="primary"
            height="40"
            width="40"
            max-width="40"
            outlined
            class="ml-8"
            @click="searchFiles"
          >
            <v-icon>mdi-filter-outline</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <div class="py-1 title">
            {{ from }} - {{ to }} of {{ totalFiles }}
          </div>
          <v-btn
            class="mx-2"
            fab
            small
            outlined
            color="primary"
            :disabled="options.page <= 1"
            @click="pageChange(false)"
          >
            <v-icon dark> mdi-chevron-left </v-icon>
          </v-btn>
          <v-btn
            class="mx-2"
            fab
            small
            outlined
            color="primary"
            :disabled="options.page >= totalPages"
            @click="pageChange(true)"
          >
            <v-icon dark> mdi-chevron-right </v-icon>
          </v-btn>
          <!-- <v-btn
                        class="mx-2"
                        fab
                        small
                        outlined
                        color="primary"
                        disabled
                    >
                        <v-icon dark>
                            mdi-cog-outline
                        </v-icon>
                    </v-btn> -->
        </div>
      </template>
      <template v-slot:progress>
        <v-progress-linear
          color="primary"
          :height="6"
          indeterminate
        ></v-progress-linear>
      </template>
      <template v-slot:no-data v-if="items.length < 1">
       {{$t('noFilesAvailable')}}
      </template>
      <template v-if="items.length > 0" v-slot:body="{ items }">
        <tbody>
          <tr
            v-for="item in items"
            :key="item.UIHNumber"
            @mouseover="selectItem(item)"
            @mouseleave="unSelectItem()"
            style="position: relative; width: 0; height: 0"
          >
            <td>
              <v-checkbox
                multiple
                v-model="selected"
                :value="item"
                style="margin: 0px; padding: 0px"
                hide-details
              />
            </td>
            <td>{{ item.UIHNumber }}</td>
            <td>{{ item.originalName }}</td>
            <td class="capitlize">{{ item.createdAt }}</td>
            <td class="capitlize text-center">
              <v-btn
                x-small
                rounded
                min-width="120"
                :color="item.status == 'pending' ? 'red2' : 'green2'"
                depressed
                :class="
                  item.status == 'pending' ? 'red--text' : 'primary--text'
                "
                height="34"
              >
                {{ item.status == "pending" ? $t('pending') : $t('complete') }}
              </v-btn>
            </td>
            <div
              style="position: absolute; right: 10px; top: 5px"
              v-if="item === selectedItem"
            >
              <!-- <v-tooltip top color="black">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    icon
                                    color="primary"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon>mdi-dots-horizontal-circle-outline</v-icon>
                                </v-btn>
                            </template>
                            <span>View</span>
                        </v-tooltip> -->
              <v-tooltip top color="black">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    x-small
                    v-bind="attrs"
                    v-on="on"
                    fab
                    class="ml-1 green-shadow"
                    @click="downloadFile(item.fileName, item.fileURL)"
                  >
                    <v-icon>mdi-export</v-icon>
                  </v-btn>
                </template>
                <span>{{$t('export')}}</span>
              </v-tooltip>
              <v-tooltip top color="black">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    x-small
                    v-bind="attrs"
                    v-on="on"
                    fab
                    class="ml-1 green-shadow"
                  >
                    <v-icon>mdi-trash-can</v-icon>
                  </v-btn>
                </template>
                <span>Remove</span>
              </v-tooltip>
            </div>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import UserService from "@/_services/UserService";
export default {
  watch: {
    options: {
      handler() {
        this.getFilesData();
      },
      deep: true,
    },
  },
  computed: {
    checkBreakPoints() {
      if (this.$vuetify.breakpoint.width <= 980) return true;
      return false;
    },
  },
  created() {
    if (this.checkBreakPoints) this.getFilesData();
  },
  data: () => ({
    options: {},
    tabletTableOptions: { itemsPerPage: 10, page: 1, sortBy: [] },
    search: "",
    from: 0,
    to: 0,
    totalFiles: 0,
    totalPages: 0,
    loading: false,
    selected: [],
    selectedItem: false,
    items: [],
    headers: [
      {
        text: this.$t("importNum"),
        align: "start",
        sortable: true,
        value: "UIHNumber",
        class: "black--text",
      },
      {
        text: this.$t("fileName"),
        value: "originalName",
        class: "black--text",
      },
      {
        text: this.$t("uploadedDate"),
        value: "createdAt",
        class: "black--text",
      },
      {
        text: this.$t("status"),
        value: "status",
        align: "center",
        sortable: false,
        class: "black--text",
      },
    ],
  }),
  methods: {
    getFilesData() {
      let tableOptions = {};
      if (this.checkBreakPoints) tableOptions = { ...this.tabletTableOptions };
      else tableOptions = { ...this.options };
      this.loading = true;
      UserService.getFilesData(tableOptions, this.search)
        .then((res) => {
          if (res.success) {
            console.log("files", res);
            this.items = res.data.userImportHistory.rows;
            this.totalFiles = res.data.userImportHistory.total_rows;
            this.showingRows = res.data.userImportHistory.num_rows;
            this.totalPages = Math.ceil(
              this.totalFiles / tableOptions.itemsPerPage
            );
            this.from = (tableOptions.page - 1) * tableOptions.itemsPerPage + 1;
            this.to =
              tableOptions.page * tableOptions.itemsPerPage -
              (tableOptions.itemsPerPage - res.data.userImportHistory.num_rows);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
          // if(err.response.status == 403)
          // this.$router.go(-1)
        });
    },

    pageChange(t) {
      if (t) this.options.page = this.options.page + 1;
      else this.options.page = this.options.page - 1;

      this.getFilesData();
    },
    tabletPageChange(t) {
      if (t) this.tabletTableOptions.page = this.tabletTableOptions.page + 1;
      else this.tabletTableOptions.page = this.tabletTableOptions.page - 1;
      this.getFilesData();
    },
    searchFiles() {
      this.getFilesData();
    },
    resetSearchOnEmpty() {
      if (this.search === "") return;
      if (this.$vuetify.breakpoint.width <= 980) {
        this.tabletTableOptions.page = 1;
      } else {
        this.options.page = 1;
      }
      this.getFilesData();
    },
    selectItem(item) {
      this.selectedItem = item;
    },
    unSelectItem() {
      this.selectedItem = false;
    },
    downloadFile(name, url) {
      // console.log(url)
      // url = 'http://3.218.20.78:3002/api/user/import/file/f8a3bbc8-b3c4-4a47-b1aa-7bb0fc523fc8.csv'
      let link = document.createElement("a");
      link.download = name;
      link.href = url;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      // delete link;
    },
  },
};
</script>